<template>
	<div>
		<AllProjectsList
			:administrator-panel="true"
		/>
	</div>
</template>

<script>
	import AllProjectsList from "./AllProjectsList";

	export default {
		name: "AllProjectsView",
		components: {AllProjectsList},
		data() {
			return {
				projects: []
			};
		}
	};
</script>

<style scoped>

</style>
